// 广告， 联名活动

const Joint = r => require.ensure(
  [],
  () => r(require('@/components/joint-activity/')),
  'Joint'
)

export default [
  // 准考证首页
  {
    path: '/joint',
    name: 'Joint',
    component: Joint,
    meta: {
      title: '联名计划'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/advertisement.js